package com.adoptu.frontend

import com.adoptu.frontend.pages.AdminPageModule
import com.adoptu.frontend.pages.AdminSheltersPageModule
import com.adoptu.frontend.pages.AdminSterilizationLocationsPageModule
import com.adoptu.frontend.pages.EditPetPageModule
import com.adoptu.frontend.pages.EmailChangeVerificationPageModule
import com.adoptu.frontend.pages.EmailVerificationPageModule
import com.adoptu.frontend.pages.ForgotPasswordPageModule
import com.adoptu.frontend.pages.IndexPageModule
import com.adoptu.frontend.pages.LoginPageModule
import com.adoptu.frontend.pages.LostFoundBrowsePageModule
import com.adoptu.frontend.pages.LostFoundDetailPageModule
import com.adoptu.frontend.pages.LostFoundResolvePageModule
import com.adoptu.frontend.pages.MagicLinkLoginPageModule
import com.adoptu.frontend.pages.MyPetsPageModule
import com.adoptu.frontend.pages.PetDetailPageModule
import com.adoptu.frontend.pages.PetFoodPageModule
import com.adoptu.frontend.pages.PhotographersPageModule
import com.adoptu.frontend.pages.ProfileEmailVerificationPageModule
import com.adoptu.frontend.pages.ProfilePageModule
import com.adoptu.frontend.pages.RegisterPageModule
import com.adoptu.frontend.pages.RescuerDetailPageModule
import com.adoptu.frontend.pages.RescuersPageModule
import com.adoptu.frontend.pages.ResetPasswordPageModule
import com.adoptu.frontend.pages.SheltersPageModule
import com.adoptu.frontend.pages.SterilizationLocationsPageModule
import com.adoptu.frontend.pages.TemporalHomeBlockPageModule
import com.adoptu.frontend.pages.TemporalHomeDetailPageModule
import com.adoptu.frontend.pages.TemporalHomeProfilePageModule
import com.adoptu.frontend.pages.TemporalHomeSearchPageModule
import com.adoptu.frontend.pages.ReportLostFoundPageModule
import com.adoptu.frontend.pages.ReportUrgentPageModule
import com.adoptu.frontend.pages.UrgentRescueAcceptPageModule
import com.adoptu.frontend.pages.UrgentRescuerDashboardPageModule
import com.adoptu.frontend.pages.UrgentRescuerLeaderboardPageModule
import com.adoptu.frontend.pages.UrgentRescuerProfilePageModule
import kotlinx.browser.window

fun main() {
    console.log("Frontend main() started, path: " + window.location.pathname)
    try {
        val path = window.location.pathname

        window.asDynamic().AdoptuI18n = I18n
        window.asDynamic().AdoptuCommon = CommonModule
        window.asDynamic().AdoptuWebAuthn = WebAuthnModule
        window.asDynamic().AdoptuIndexPage = IndexPageModule
        window.asDynamic().AdoptuLoginPage = LoginPageModule
        window.asDynamic().AdoptuProfilePage = ProfilePageModule
        window.asDynamic().AdoptuRegisterPage = RegisterPageModule
        window.asDynamic().AdoptuMyPets = MyPetsPageModule

        window.asDynamic().t = { k: String -> I18n.t(k) }
        window.asDynamic().tCountry = { n: String -> I18n.translateCountry(n) }

        CommonModule.initClickActions()
        CommonModule.initDropdowns()
        CommonModule.initLocationSearchFilters()
        CommonModule.initAuthNav()
        CommonModule.initDeploySequence()
        CommonModule.initServiceWorker()
        CommonModule.initInstallPrompt()
        CommonModule.initBackLinks()

        CommonModule.initI18nForSession().then<Unit> {
            try {
                when {
                    path == "/" || path == "/pets" -> IndexPageModule.init()
                    path == "/logout" -> ApiClientModule.logout().then<Unit> { window.location.replace("/") }.catch<Unit> { window.location.replace("/") }
                    path == "/login" || path == "/login/" -> LoginPageModule.init()
                    path == "/register" || path == "/register/" -> RegisterPageModule.init()
                    path == "/profile" || path == "/profile/" -> ProfilePageModule.init()
                    path == "/my-pets" || path == "/my-pets/" -> MyPetsPageModule.init()
                    path == "/edit-pet" || path == "/edit-pet/" -> EditPetPageModule.init()
                    path.startsWith("/pet/") -> PetDetailPageModule.init()
                    path == "/pet-food" || path == "/pet-food/" -> PetFoodPageModule.init()
                    path == "/shelters" || path == "/shelters/" -> SheltersPageModule.init()
                    path == "/admin-shelters" || path == "/admin-shelters/" || path == "/admin/shelters" || path == "/admin/shelters/" -> AdminSheltersPageModule.init()
                    path == "/temporal-homes" || path == "/temporal-homes/" -> TemporalHomeSearchPageModule.init()
                    path == "/temporal-home" || path == "/temporal-home/" -> TemporalHomeProfilePageModule.init()
                    path == "/temporal-home/block" -> TemporalHomeBlockPageModule.init()
                    path.startsWith("/temporal-home/") -> TemporalHomeDetailPageModule.init()
                    path == "/photographers" || path == "/photographers/" -> PhotographersPageModule.init()
                    path == "/sterilization-locations" || path == "/sterilization-locations/" -> SterilizationLocationsPageModule.init()
                    path == "/admin-sterilization-locations" || path == "/admin-sterilization-locations/" || path == "/admin/sterilization-locations" || path == "/admin/sterilization-locations/" -> AdminSterilizationLocationsPageModule.init()
                    path == "/admin" || path == "/admin/" -> AdminPageModule.init()
                    path == "/forgot-password" || path == "/forgot-password/" -> ForgotPasswordPageModule.init()
                    path == "/reset-password" || path == "/reset-password/" -> ResetPasswordPageModule.init()
                    path == "/magic-link-login" || path == "/magic-link-login/" -> MagicLinkLoginPageModule.init()
                    path == "/verify" || path == "/verify/" || path == "/verify-email" || path == "/verify-email/" -> EmailVerificationPageModule.init()
                    path == "/verify-email-change" || path == "/verify-email-change/" -> EmailChangeVerificationPageModule.init()
                    path == "/verify-profile-email" || path == "/verify-profile-email/" -> ProfileEmailVerificationPageModule.init()
                    path == "/report-urgent" || path == "/report-urgent/" -> ReportUrgentPageModule.init()
                    path == "/urgent-rescuer-profile" || path == "/urgent-rescuer-profile/" -> UrgentRescuerProfilePageModule.init()
                    path == "/urgent-rescuer-dashboard" || path == "/urgent-rescuer-dashboard/" -> UrgentRescuerDashboardPageModule.init()
                    path == "/urgent-rescuer-leaderboard" || path == "/urgent-rescuer-leaderboard/" -> UrgentRescuerLeaderboardPageModule.init()
                    path == "/urgent-rescue-accept" || path == "/urgent-rescue-accept/" -> UrgentRescueAcceptPageModule.init()
                    path == "/report-lost-found" || path == "/report-lost-found/" -> ReportLostFoundPageModule.init()
                    path == "/lost-found" || path == "/lost-found/" -> LostFoundBrowsePageModule.init()
                    path == "/lost-found-resolve" || path == "/lost-found-resolve/" -> LostFoundResolvePageModule.init()
                    path.startsWith("/lost-found/") -> LostFoundDetailPageModule.init()
                    path == "/rescuers" || path == "/rescuers/" -> RescuersPageModule.init()
                    path.startsWith("/rescuer/") -> RescuerDetailPageModule.init()
                    else -> {}
                }
            } catch (e: dynamic) {}
        }
    } catch (e: dynamic) {}
}
